// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

// Query String
const queryString = require('querystring');

class bundlesAPI extends MainAPI {
	/**
	 * @return {object} list of bundles
	 * @params queryParams
	 * */
	async getBundles(queryParams) {
		return API.get(`${ENDPOINTS.GET_BUNDLES}?${queryString.stringify(queryParams)}`);
	}

	/**
	 * @return {object} bundle
	 * @param bundleId
	 * */
	async getBundleById(bundleId) {
		return API.get(`${ENDPOINTS.GET_BUNDLES_BY_ID}/${bundleId}`);
	}

	/**
	 * @return {object} bundle list
	 * @param body - bundle name
	 */
	async getBundleByName(body) {
		return API.get(ENDPOINTS.GET_BUNDLE_CHECK, body);
	}

	/**
	 * @param bundleId
	 * */
	async putReactivateBundle(bundleId) {
		return API.put(`${ENDPOINTS.PUT_BUNDLE}/${bundleId}/reactivate`);
	}

	/**
	 * @return no content
	 * @param bundleDetails
	 * */
	async postAddBundle(bundleDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(bundleDetails.formDetails)
		);

		newFormData.append(
			'bundleImage',
			bundleDetails.bundleImage
		);

		return API.post(ENDPOINTS.POST_BUNDLE, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	/**
	 * @return no content
	 * @param bundleId
	 * @param bundleDetails
	 * */
	async putUpdateBundle(bundleId, bundleDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(bundleDetails.formDetails)
		);

		newFormData.append(
			'bundleImage',
			bundleDetails.bundleImage
		);

		return API.put(`${ENDPOINTS.PUT_BUNDLE}/${bundleId}`, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	/**
	 * @param bundleId
	 * */
	async deleteBundle(bundleId) {
		return API.delete(`${ENDPOINTS.DELETE_BUNDLE}/${bundleId}`);
	}

	/**
	 * @return no content
	 * @param bundleDetails
	 * */
	async postDogBundle(bundleDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(bundleDetails.formDetails)
		);

		newFormData.append(
			'bundleImage',
			bundleDetails.bundleImage
		);

		return API.post(ENDPOINTS.POST_DOG_BUNDLE, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	/**
	 * @return no content
	 * @param bundleId
	 * @param bundleDetails
	 * */
	async putDogBundle(bundleId, bundleDetails) {
		let newFormData = new FormData();

		newFormData.append(
			'formData',
			JSON.stringify(bundleDetails.formDetails)
		);

		newFormData.append(
			'bundleImage',
			bundleDetails.bundleImage
		);

		return API.put(`${ENDPOINTS.PUT_DOG_BUNDLE}/${bundleId}`, newFormData, {
			header: {
				'Content-Type': 'multipart/form-data'
			}
		});
	}

	/**
	 * @param bundleId
	 * */
	async bundleDelete(bundleId) {
		return API.delete(`${ENDPOINTS.DELETE_BUNDLE}/${bundleId}/delete`);
	}
}

export default new bundlesAPI();
